export default "__VITE_ASSET__IJTPbM14__"